import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { initBlock, resetBlock , goToPage} from './SpeedTestAndDisconnectionsWizardBlockSlice';
import  AutomaticRouterInitializationPage  from './pages/AutomaticRouterInitializationPage/AutomaticRouterInitializationPage';
import SubscriberPage from './pages/SubscriberPage/SubscriberPage';
import MessagePage from './pages/MessagePage/MessagePage';
import LoaderPage from './pages/LoaderPage/LoaderPage';
import RedirectManualInitializationPage from './pages/RedirectManualInitializationPage/RedirectManualInitializationPage';
import arrow from './images/arrow.svg';

const SpeedTestAndDisconnectionsWizardBlock = (props) => {
    let currentView = null;


    useExtendedEffect((runSideEffects) => {
        props.initBlock({ epiBlockData: props.iContent, page: 'SubscriberPage' });
        if (runSideEffects()) {
        }
        return () => {
          if (runSideEffects()) {
            props.resetBlock();
          }
        };
      }, []);

      useClearStateResetFlag();

      const handleOnLinkClick = ()=>{
        window.history.back()
      };

      switch (props.page) {
        case 'SubscriberPage': currentView = <SubscriberPage/>; break;
        case 'MessagePage': currentView = <MessagePage />; break;
        case 'AutomaticRouterInitializationPage': currentView = <AutomaticRouterInitializationPage/>; break;
        case 'LoaderPage': currentView = <LoaderPage/>; break;
        case 'RedirectManualInitializationPage': currentView = <RedirectManualInitializationPage/>; break;
      }

    return (
        <div className='speed-test-and-disconnections-wizard-block'>
            <div className='wrapper-back-button'>
                <a href='#' className='button' onClick={handleOnLinkClick}> <Image src={arrow} alt='icon' /> חזרה </a>
            </div>
            <div className='page-wrapper'>{currentView}</div>
        </div>
      );
};

const mapStateToProps = (state) => {
    return {
        page: state.speedTestAndDisconnectionsWizardBlock.page,
    };
};

const mapDispatchToProps = {
    resetBlock,
    initBlock,
    goToPage
};

export default connect(mapStateToProps, mapDispatchToProps)(SpeedTestAndDisconnectionsWizardBlock);
